import React, { useState, useRef, useImperativeHandle, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";

// import QuillComponent from "util/component/Quill";

import "./custom.scss";

import "./styles.scss";

const Editor = (props, _ref) => {
    const [Hide, SetHide] = useState(false);
    const quillRef = useRef(null);

    const HandleHide = () => {
        SetHide(!Hide);
    }

    useImperativeHandle(_ref, () => ({
        getValue: () => {
            return quillRef.current?.getData();
        },
    }));
    useEffect(() => {
        const mouseUp = (e) => {
            const selection= window.getSelection();
            if(selection.type?.toString().toUpperCase() === "RANGE") {
                
                const selectionNext = selection.getRangeAt(0);
                const checktype = selectionNext.commonAncestorContainer.nodeName;
            }
        }

        window.addEventListener("mouseup", mouseUp)
        return () => {
            window.removeEventListener("mouseup", mouseUp);
        }
    },[props])

  

    return (
        <section className="preview">
            <div className={"tbl_box2 " + (Hide ? "hide" : "")}>
                <h1 className={"title "} onClick={HandleHide}>
                    {"Description"} <FontAwesomeIcon icon={faAngleUp} />
                </h1>
                <div className="data_table data_page">
                    {/* <QuillComponent ref={quillRef} value={props?.webContent} /> */}
                    <div className={"ck-content ck-readnonly"} dangerouslySetInnerHTML={{__html: props?.webContent}}></div>
                </div>
            </div>
        </section>
    );
};

export default React.forwardRef(Editor);
